import {deviceService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      deviceService: undefined
    };
  },
  created: function() {
    this.deviceService = deviceService;
  }
};
